module.exports = __webpack_public_path__ + "img/dxctj-6000.f3bf2446.jpg";